enum PermissionType {
	Read = 'Read',
	Write = 'Write',
}

export default PermissionType;
